import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelResumeComponent } from './hotel-resume.component';
import { RatingModule } from 'libraries/component/rating/rating.module';
import { DatePipeModule } from 'libraries/date/date.module';
import { LabelService } from 'libraries/service/label/label.service';
import { SearchHotelFormService } from '../../containers/search-hotel-form/services/search-hotel-form.service';
import { DeltaPriceModule } from '../delta-price/delta-price.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { CancellationConditionsModule } from '../cancellation-conditions/cancellation-conditions.module';
import { PriceDetailsModule } from '../price-details/price-details.module';
import { MealPlanModule } from 'libraries/component/meal-plan/meal-plan.module';
import { QuotationService } from 'libraries/hotel/services/quotation/quotation.service';
import { RequestStatusModule } from '../request-status/request-status.module';
import { AddressModule } from 'libraries/component/address/address.module';
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PermissionModule } from "../../../permission/permission.module";

@NgModule({
    declarations: [
        HotelResumeComponent,

    ],
    imports: [
        AddressModule,
        CommonModule,
        RatingModule,
        PriceDetailsModule,
        DatePipeModule,
        DeltaPriceModule,
        BtnModule,
        CancellationConditionsModule,
        MealPlanModule,
        RequestStatusModule,
        HostAliasPipeModule,
        FontAwesomeModule,
        PermissionModule,
    ],
    exports: [
        HotelResumeComponent,
    ],
    providers: [
        LabelService,
        SearchHotelFormService,
        QuotationService,
    ],
})
export class HotelResumeModule {
}
